import {z} from 'zod';

import {DocumentPreviewBasePageSchema} from './DocumentPreviewBasePage';
import {DocumentPreviewPageValidationStatusSchema} from './DocumentPreviewPageValidationStatus';

export const DocumentPreviewPageSchema = DocumentPreviewBasePageSchema.extend({
  validationStatus: DocumentPreviewPageValidationStatusSchema,
});

export type DocumentPreviewPage = z.infer<typeof DocumentPreviewPageSchema>;
